import styled from 'styled-components'

export const PopupBlockerContentContainer = styled.div``

export const LinkWrapper = styled.span`
  color: ${({ theme }) => theme.palette.blue100};
  margin-left: 3px;
  text-decoration: underline;
`
